import {
    PHONE_VERIFICATION_CALL_ME_CODE,
    PHONE_VERIFICATION_CHANGE_NUMBER_BTN,
    PHONE_VERIFICATION_CONTACTING_YOU_ON_number_change,
    PHONE_VERIFICATION_COUNTRY_PREFIX,
    PHONE_VERIFICATION_EXPLANATION_FREE,
    PHONE_VERIFICATION_I_HAVE_FOREIGN_PHONE_NUMBER,
    PHONE_VERIFICATION_I_HAVE_LOCAL_PHONE_NUMBER,
    PHONE_VERIFICATION_SEND_ME_CODE,
    PHONE_VERIFICATION_TOKEN_CALL_LABEL,
    PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_CALL,
    PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_SMS,
    PHONE_VERIFICATION_TOKEN_SMS_LABEL,
    PHONE_VERIFICATION_VALIDATE_TOKEN,
    PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_CALL,
    PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_SMS,
    PHONE_VERIFICATION_YOUR_LOCAL_PHONE_NUMBER,
    PHONE_VERIFICATION_YOUR_MOBILE_NUMBER,
} from 'mk/autogenerated/translations/PhoneVerificationForm.12aca4e135a30ba777ed66c498791f24'
import { FOREIGN_COUNTRIES_PHONE_PREFIXES_OPTIONS, HOME_COUNTRY_PHONE_PREFIX } from 'mk2/apps/users/constants';
import { PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER } from 'mk2/apps/users/containers/PhoneVerification/PhoneVerification.actions';
import { hasValidationViaSms, prettyNumber } from 'mk2/apps/users/utils';
import { InputField } from 'mk2/components/forms/InputField';
import { SelectField } from 'mk2/components/forms/SelectField';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { Btn,  BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { FormPageType } from 'mk2/constants/enums';
import ActionButton from 'mk2/containers/ActionButton/ActionButton';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import React from 'react';
import styles from './PhoneVerificationForm.mscss';

export const PHONE_VERIFICATION_FORM_NAME = 'PHONE_VERIFICATION_FORM';

interface OwnProps {
    step1Title: string;
    step1ExplanationSms: string;
    step1ExplanationCall: string;
    initialValues: PhoneVerificationFormData;
    currentValues: PhoneVerificationFormData;
    onRequestToken(countryPrefix: string, rawPhoneNumber: string, resend: boolean);
    onValidateToken(token: string, fullPhoneNumber: string);
}

interface OwnState {
    foreignNumber: boolean;
}

export interface PhoneVerificationFormData {
    countryPrefix: string;
    rawPhoneNumber: string;  // cislo co zadal uzivatel, mozno s 0 navyse na zaciatku, napr. 0903707656
    fullPhoneNumber: string; // cislo normalizovne na backende s country prefixom, napr. +421903707656
    token: string;
}

export type Props = OwnProps;

export class PhoneVerificationFormComponent extends React.Component<Props & MKReduxFormInjectedProps<PhoneVerificationFormData, Props>, OwnState> {
    public state: OwnState = {
        foreignNumber: false,
    };

    public render() {
        const {currentFormPage} = this.props;
        if (currentFormPage === FormPageType.PhoneVerificationTokenValidation) {
            return this.renderTokenValidation();
        }  else {
            return this.renderMain();
        }
    }

    public renderMain() {  // step 1
        const { currentValues, step1Title, step1ExplanationCall, step1ExplanationSms } = this.props;

        return(
            <div className={styles.PhoneVerificationForm}>
                <div>
                    <div className={styles.PhoneVerificationForm__textWrapper}>
                        <h1 className={styles.PhoneVerificationForm__title}>{step1Title}</h1>
                        <p className={styles.PhoneVerificationForm__text}>
                            <Interpolate
                                i18nKey={hasValidationViaSms(!this.state.foreignNumber ? HOME_COUNTRY_PHONE_PREFIX : currentValues.countryPrefix)
                                    ? step1ExplanationSms
                                    : step1ExplanationCall
                                }
                                price={<strong>{PHONE_VERIFICATION_EXPLANATION_FREE}</strong>}
                            />
                        </p>
                    </div>
                    {this.state.foreignNumber &&
                        <SelectField
                            name="countryPrefix"
                            label={PHONE_VERIFICATION_COUNTRY_PREFIX}
                            options={FOREIGN_COUNTRIES_PHONE_PREFIXES_OPTIONS}
                        />
                    }
                    <InputField
                        name="rawPhoneNumber"
                        type="text"
                        label={!this.state.foreignNumber
                            ? PHONE_VERIFICATION_YOUR_LOCAL_PHONE_NUMBER
                            : PHONE_VERIFICATION_YOUR_MOBILE_NUMBER}
                    />
                    <div className={styles.PhoneVerificationForm__phoneActions}>
                        <ActionButton
                            key="send-token-btn"
                            type={BtnType.Blue}
                            label={hasValidationViaSms(!this.state.foreignNumber ? HOME_COUNTRY_PHONE_PREFIX : currentValues.countryPrefix)
                                ? PHONE_VERIFICATION_SEND_ME_CODE
                                : PHONE_VERIFICATION_CALL_ME_CODE
                            }
                            onClick={this.handleRequestToken}
                            triggerAction={PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER}
                            showSpinnerWhenBusy
                        />
                        <Btn
                            key="foreign-number-btn"
                            onClick={this.handleForeignNumberClick}
                            label={!this.state.foreignNumber
                                ? PHONE_VERIFICATION_I_HAVE_FOREIGN_PHONE_NUMBER
                                : PHONE_VERIFICATION_I_HAVE_LOCAL_PHONE_NUMBER}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{
                                label: styles.PhoneVerificationForm__secondaryBtn,
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    public renderTokenValidation() {  // step 2
        const { currentValues, form } = this.props;

        return(
            <div className={styles.PhoneVerificationForm}>
                <div>
                    <div className={styles.PhoneVerificationForm__textWrapper}>
                        <h1 className={styles.PhoneVerificationForm__title}>
                           {hasValidationViaSms(currentValues.fullPhoneNumber)
                                ? PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_SMS
                                : PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_CALL}
                        </h1>
                        <Interpolate
                            className={styles.PhoneVerificationForm__number}
                            i18nKey={PHONE_VERIFICATION_CONTACTING_YOU_ON_number_change}
                            number={(
                                <strong>
                                    {prettyNumber(currentValues.fullPhoneNumber)}
                                </strong>
                            )}
                            change={
                                <Btn
                                    label={PHONE_VERIFICATION_CHANGE_NUMBER_BTN}
                                    sidePadding={BtnSidePadding.None}
                                    type={BtnType.BlueTextLight}
                                    onClick={this.handleChangeNumberClick}
                                />
                            }
                        />
                    </div>
                    <InputField
                        name="token"
                        type="text"
                        label={hasValidationViaSms(currentValues.fullPhoneNumber)
                            ? PHONE_VERIFICATION_TOKEN_SMS_LABEL
                            : PHONE_VERIFICATION_TOKEN_CALL_LABEL}
                    />
                    <div className={styles.PhoneVerificationForm__phoneActions}>
                        <SubmitButton
                            label={PHONE_VERIFICATION_VALIDATE_TOKEN}
                            formName={form}
                        />
                        <Btn
                            onClick={this.handleResendToken}
                            label={hasValidationViaSms(currentValues.fullPhoneNumber)
                                ? PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_SMS
                                : PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_CALL
                            }
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{
                                label: styles.PhoneVerificationForm__secondaryBtn,
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private handleRequestToken = () => {
        const { onRequestToken, currentValues } = this.props;
        onRequestToken(
            !this.state.foreignNumber ? HOME_COUNTRY_PHONE_PREFIX : currentValues.countryPrefix,
            currentValues.rawPhoneNumber, false);
    };

    private handleResendToken = () => {
        const { onRequestToken, currentValues } = this.props;
        onRequestToken(
            !this.state.foreignNumber ? HOME_COUNTRY_PHONE_PREFIX : currentValues.countryPrefix,
            currentValues.rawPhoneNumber, true);
    };

    private handleForeignNumberClick = () => {
        this.setState({foreignNumber: !this.state.foreignNumber});
    };

    private handleChangeNumberClick = () => {
        const { onOpenFormPage } = this.props;
        onOpenFormPage(FormPageType.Main);
    };
}

export const PhoneVerificationForm = mkReduxForm<PhoneVerificationFormData, Props>({
    formName: PHONE_VERIFICATION_FORM_NAME,
    onValidate: () => ({/* nothing to do, validation on server side */}),
    onSave: (values, props) => props.onValidateToken(values.token, values.fullPhoneNumber),
    disableDirtyCheck: true,
})(PhoneVerificationFormComponent);
